import { render } from "./DropDownSections.vue?vue&type=template&id=af5a951a&ts=true"
import script from "./DropDownSections.vue?vue&type=script&lang=ts"
export * from "./DropDownSections.vue?vue&type=script&lang=ts"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__